import { useState } from 'react';
import Accordion from '../resuable-components/Accordion';

const FAQSection = () => {
  const faqs = [
    {
      question: "How do I open an EximPe Global Trade Account?",
      answer: (
        <>
          Visit{" "}
          <a
            href="https://app.eximpe.com/auth/sign-up "
            className="font-bold italic underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            our sign-up page
          </a>{" "}
          to create an account. Complete KYC verification to activate your account within 48 hours.
        </>
      ),
    },
    {
      question: "What currencies are supported?",
      answer: "Currently we support US dollars, Euros, Pound Sterling, Japanese Yen, and AED (United Arab Emirates Dirham).",
    },
    {
      question: "What are the documents required to open an account?",
      answer: (
        <>
          <p>The required documents vary based on the type of company. You can find out which documents are needed by selecting your company type during the account opening process.</p>
        </>
      ),
    },
    {
      question: "How long will it take to open an account?",
      answer: "Once you have submitted the documents, our team will conduct a physical verification and complete the process within a week.",
    },
    {
      question: "What are the charges involved?",
      answer: "There are no charges for using the service.",
    },
    {
      question: "Can I receive the funds to my existing bank account?",
      answer: "EximPe Global trade account is powered by a current account provided by the leading Indian banks. You can transfer the fund from the current account to any account as you wish.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <section className="bg-white mt-[10px]  lg:px-[15%]">
      <div className="container mx-auto  px-4">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-[#1A202C] mb-12">
          FAQs
        </h2>
        <div className="max-w-3xl  mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              title={faq.question}
              content={faq.answer}
              isOpen={activeIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;